import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { Eye, EyeSlash, Leaf } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate("/admin/dashboard");
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: "#F7F5F0" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-4" style={{ backgroundColor: "rgba(26, 92, 55, 0.1)" }}>
            <Leaf size={28} weight="duotone" style={{ color: "#1A5C37" }} />
          </div>
          <h1 className="font-heading text-2xl font-semibold tracking-tight" style={{ color: "#1A5C37" }}>KYBIA Admin</h1>
          <p className="text-sm mt-1" style={{ color: "#4A5450" }}>Sign in to access the admin panel</p>
        </div>

        <div className="rounded-2xl border p-8" style={{ backgroundColor: "#fff", borderColor: "rgba(26, 92, 55, 0.12)", boxShadow: "0 4px 24px rgba(26,92,55,0.07)" }}>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-medium mb-1.5 uppercase tracking-wider" style={{ color: "#4A5450" }}>Email</label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                placeholder="admin@example.com"
                className="w-full px-4 py-3 rounded-lg border text-sm outline-none transition-colors"
                style={{ borderColor: "rgba(26, 92, 55, 0.2)", backgroundColor: "#F7F5F0", color: "#1C211F" }}
                onFocus={(e) => (e.target.style.borderColor = "#1A5C37")}
                onBlur={(e) => (e.target.style.borderColor = "rgba(26, 92, 55, 0.2)")}
              />
            </div>

            <div>
              <label className="block text-xs font-medium mb-1.5 uppercase tracking-wider" style={{ color: "#4A5450" }}>Password</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required
                  placeholder="••••••••"
                  className="w-full px-4 py-3 pr-11 rounded-lg border text-sm outline-none transition-colors"
                  style={{ borderColor: "rgba(26, 92, 55, 0.2)", backgroundColor: "#F7F5F0", color: "#1C211F" }}
                  onFocus={(e) => (e.target.style.borderColor = "#1A5C37")}
                  onBlur={(e) => (e.target.style.borderColor = "rgba(26, 92, 55, 0.2)")}
                />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 p-1" style={{ color: "#4A5450" }}>
                  {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            {error && (
              <p className="text-xs px-3 py-2 rounded-lg" style={{ color: "#B85C38", backgroundColor: "rgba(184, 92, 56, 0.08)" }}>{error}</p>
            )}

            <button
              type="submit" disabled={loading}
              className="w-full py-3 rounded-lg text-sm font-medium transition-colors duration-200 mt-2"
              style={{ backgroundColor: loading ? "#4a8c62" : "#1A5C37", color: "#F7F5F0", cursor: loading ? "not-allowed" : "pointer" }}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>

        <p className="text-center text-xs mt-6" style={{ color: "#4A5450" }}>KYBIA Admin Panel &mdash; Authorised Access Only</p>
      </div>
    </div>
  );
}
